import * as Cookies from 'js-cookie'

export default {
  saveHead(state,handimg){
    state.loginState.userInfo.headImg = handimg
    Cookies.set('loginState', state.loginState, {expires: 1});
  },
  savetheme(state,theme){
    state.loginState.theme = theme;
  },
	saveLoginState(state, userInfo) {
		state.loginState.isLogin = true;
		state.loginState.userInfo = userInfo;
    Cookies.set('loginState', state.loginState, {expires: 1});
	},
	loginOut(state) {
		state.loginState.isLogin = false;
		state.loginState.userInfo = {};
    state.token = '';
    Cookies.remove('loginState');
    Cookies.remove('token');
	},
  saveToken(state,token) {
    state.token = token;
    Cookies.set('token', state.token, {expires: 1});
  },
  syncLoginState (state) {
	  let cookieState = Cookies.getJSON('loginState');
    if (cookieState) {
      state.loginState = cookieState;
    }
    let cookieToken = Cookies.getJSON('token');
    if (cookieToken) {
      state.token = cookieToken;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js